module.exports = __webpack_public_path__ + "img/cancel_icon.d31aa3b3.svg";